import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/_services/auth.service';
import { environment } from 'src/environments/environment';
// Highlight JS
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SplashScreenModule } from './_Core/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { HotToastModule } from '@ngneat/hot-toast';
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { HomeComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { SpecialtiesComponent } from './components/pages/specialties/specialties.component';
import { SignupComponent } from './components/pages/signup/signup.component';
import { LoginComponent } from './components/pages/login/login.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { BoardComponent } from './components/pages/board/board.component';
import { HopitalComponent } from './components/pages/hopitals/hospital.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlogDetailsModalComponent } from './components/pages/blog/blog-details-modal/blog-details-modal.component';
import { DeleteAccountModalComponent } from './components/pages/profile-settings/delete-account-modal/delete-account-modal.component';
import { SocialMediaComponent } from './components/pages/social-media/social-media.component';
import { LayoutModule } from '@angular/cdk/layout';
import { LanguageModule } from './modules/auth/login/language/language.module';
import { NgImageSliderModule } from 'ng-image-slider';
import { SafeUrlPipe } from './components/pages/safeUrl.pipe';
import {MatDialogModule} from '@angular/material/dialog';
import { ForgetPasswordComponent } from './components/pages/forget-password/forget-password.component';
import { ChangePasswordComponent } from './components/pages/change-password/change-password.component';
import { EnvServiceProvider } from './service/env.service.provider';
import { StaffLoginComponent } from './components/pages/staff-login/staff-login.component';
import { CongratsComponent } from './components/pages/congrats/congrats.component';
import { CongratsEditModalComponent } from './components/pages/congrats/congrats-edit-modal/congrats-edit-modal.component';
import { PageQrComponent } from './components/pages/page-qr/page-qr.component';
import { CongratsCardsEditComponent } from './components/pages/congrats/congrats-cards-edit/congrats-cards-edit.component';
import { ProfileSettingsComponent } from './components/pages/profile-settings/profile-settings.component';
import { DownloadReportComponent } from './components/pages/download-report/downoad-report.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DoctorSlotsComponent } from './components/pages/doctor-slots/doctor-slots.component';
import { AppointmentsModule } from './modules/appointments/appointments.module';
import { AddComplaintSuggestionComponent } from './components/pages/add-complaint-suggestion/add-complaint-suggestion.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { TruncateWordsPipe } from './Shared/pipe/TruncateWordsPipe.pipe';
import { AddEditSurveyComponent } from './components/pages/add-edit-survey/add-edit-survey.component';
import { MedicineLogComponent } from './components/pages/medicine-log/medicine-log.component';
import { OffersComponent } from './components/pages/offers/offers.component';
import { BookOfferComponent } from './components/pages/offers/book-offer/book-offer.component';
import { InvestmentComponent } from './components/pages/investment/investment.component';
import { CareerComponent } from './components/pages/career/career.component';

// #fake-end#

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}


@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    FooterComponent,
    NavbarComponent,
    HomeComponent,
    AboutComponent,
    SpecialtiesComponent,
    SignupComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    ErrorComponent,
    HopitalComponent,
    BlogComponent,
    ContactComponent,
    BoardComponent,
    BlogDetailsModalComponent,
    DeleteAccountModalComponent,
    SocialMediaComponent,
    SafeUrlPipe,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    StaffLoginComponent,
    CongratsComponent,
    CongratsEditModalComponent,
    PageQrComponent,
    CongratsCardsEditComponent,
    ProfileSettingsComponent,
    DownloadReportComponent,
    DoctorSlotsComponent,
    AddComplaintSuggestionComponent,
    BlogDetailsComponent,
    TruncateWordsPipe,
    AddEditSurveyComponent,
    MedicineLogComponent,
    OffersComponent,
    BookOfferComponent,
    InvestmentComponent,
    CareerComponent
  ],
  imports: [
    NgbModule,
    LanguageModule,
    LayoutModule,
    NgxSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    SplashScreenModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    HighlightModule,
    ClipboardModule,
    // MatFormFieldModule,
    // MatDialogModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    NgImageSliderModule,
    // #fake-start#
    environment.isMockEnabled
      ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
        passThruUnknownUrl: true,
        dataEncapsulation: false,
      })
      : [],
    // #fake-end#
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    HotToastModule.forRoot(),
    NgSelectModule,
    AppointmentsModule
  ],
  providers: [
    EnvServiceProvider,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
          json: () => import('highlight.js/lib/languages/json')
        },
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
